export enum PdfReportTypes {
  MOTIVE = 'motive',
  LEAD = 'lead',
}
